module.exports = "\r\nh1 {\r\n  color: #369;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  font-weight: bold;\r\n}\r\n\r\n.container{\r\n  text-align: center;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main